import { render } from "./AnniversarySlider.vue?vue&type=template&id=9229c704"
import script from "./AnniversarySlider.vue?vue&type=script&lang=js"
export * from "./AnniversarySlider.vue?vue&type=script&lang=js"

import "./AnniversarySlider.vue?vue&type=style&index=0&id=9229c704&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__